/* eslint-disable max-len */
/* THIS IS GENERATED BY generateBlockMaps.js - PLEASE DO NOT EDIT */
import {
    MortgageAgentDirectoryTable,
    ProductTableBestMortgageRates,
} from '@ratehub/web-components';


const BLOCK_TO_COMPONENT_MAP = {
    [MortgageAgentDirectoryTable.blockKey]: { render: MortgageAgentDirectoryTable },
    [ProductTableBestMortgageRates.blockKey]: { render: ProductTableBestMortgageRates },
};

export default BLOCK_TO_COMPONENT_MAP;
